<template>
  <div class="viewUserRegistration">
    <h1>View the UserInfo data</h1>
    <div v-for="item in userInfos" :key="item.id">
      <h3>{{ item.userFirst }}</h3>
      <p>{{ item.userLast }}</p>
      <p>{{ item.email }}</p>
      <p>{{ item.phone1 }}</p>
      <p>{{ item.phone2 }}</p>
      <p>{{ item.address1 }}</p>
      <p>{{ item.address2 }}</p>
      <p>{{ item.address3 }}</p>
      <p>{{ item.City }}</p>
      <p>{{ item.state }}</p>
      <p>{{ item.zip }}</p>
      <p>{{ item.zip4 }}</p>
      <p>{{ item.country }}</p>
      <p>{{ item.activeUser }}</p>
      <p>{{ item.premiumUser }}</p>
    </div>
  </div>
</template>

<script>
import { API } from "aws-amplify";
import { listUserInfos } from "@/graphql/queries";

export default {
  name: "ViewUserRegistration",
  async created() {
    this.listUserInfos();
  },
  data() {
    return {
      userFirst: "",
      userLast: "",
      email: "",
      phone1: "",
      phone2: "",
      address1: "",
      address2: "",
      address3: "",
      City: "",
      state: "",
      zip: "",
      zip4: "",
      country: "",
      activeUser: "",
      premiumUser: "",
      userInfos: []
    };
  },
  methods: {
    async listUserInfos() {
      const userInfos = await API.graphql({
        query: listUserInfos,
        authMode: "AMAZON_COGNITO_USER_POOLS"
      });
      this.userInfos = userInfos.data.listUserInfos.items;
    }
  }
};
</script>
